var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelimitWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 32,
    viewBox: "0 0 55 32",
    fill: "#C0C8D7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3498 0.223145C30.716 0.223145 23.7227 7.2165 23.7227 15.8503C23.7227 24.484 30.716 31.4774 39.3498 31.4774C47.9836 31.4774 54.9769 24.484 54.9769 15.8503C54.9769 7.2165 47.9836 0.223145 39.3498 0.223145ZM45.8251 17.5338H39.3498C38.6591 17.5338 38.0979 16.9726 38.0979 16.2819V8.16622C38.0979 7.47554 38.6591 6.91433 39.3498 6.91433C40.0405 6.91433 40.6017 7.47554 40.6017 8.16622V15.0732H45.8251C46.5158 15.0732 47.077 15.6344 47.077 16.3251C47.077 16.9727 46.5158 17.5338 45.8251 17.5338Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 11,
    height: 3,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 19,
    height: 3,
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 9,
    height: 3,
    rx: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelimitWarningIcon);
export default __webpack_public_path__ + "static/media/timelimit_warning_icon.7cd0c87c166cfc017833fc9d9192f691.svg";
export { ForwardRef as ReactComponent };